<!--
################################################################################################
######    Vista SVC91000  :  Formulario Pago TPV (Redsys) - Petición Autorización (1/3)   ######
################################################################################################
-->

<template>
<div>
  
  <!-- 
  <TNC10000></TNC10000>

  <div class="igs-color2 igs-center igs-bold">
    <br/>
    TPV Virtual RedSys
  </div>
  -->

  <div>

    <!--
    <br/><br/>
    <img :src="f99ImageName('logo_ihoreca')" height="96"> 
    -->
    <br/>
    <div class="igs-h4 igs-color1 igs-center">Importe a Pagar</div>
    <br/>

    <div class="row">
      <div class="col-2">&nbsp;</div>
      <div class="col-4 igs-center"><img :src="f99ImageName('ih1-importe-azul')" height="64"></div>
      <div class="col-4 igs-h4 igs-color1 igs-center igs-v-center">{{$store.state.strTPVMensajeImporte}}</div>
      <div class="col-2">&nbsp;</div>
    </div>

    <div><hr/></div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center">Medio de Pago<br/></div>
    </div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center">
        <img :src="f99ImageName('ih1-tarjeta-bancaria-azul')"                 height="64" v-if="!lbOperacionBizum && !lbOperacionAutenticacion">
        <img :src="f99ImageName('ih1-tarjeta-bancaria-autenticacion-azul')"   height="64" v-if="lbOperacionAutenticacion">
        <img :src="f99ImageName('ih1-bizum-azul')"                            height="64" v-if="lbOperacionBizum">
      </div>
    </div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center" v-if="!lbOperacionBizum && !lbOperacionAutenticacion">Tarjeta Bancaria</div>
      <div class="col-12 igs-h4 igs-center" v-if="lbOperacionAutenticacion">Pre-Autorización Bancaria</div>
      <div class="col-12 igs-h4 igs-center" v-if="lbOperacionBizum">Bizum</div>
    </div>

    <div><hr/></div>

    <div class="row" v-if="lbMostrarGuardarTarjeta">
      <div class="col-9 igs-l3 igs-center">
        <label class="form-check-label" for="defaultCheck1">Deseo guardar los datos de la tarjeta para próximas compras</label>
      </div>
      <div class="col-1">&nbsp;</div>
      <div class="col-1 igs-v-center igs-center">
          <input class="form-check-input" style="width:20px; height:20px;" type="checkbox" id="Ds_GuardarTarjeta" ref="rfGuardarTarjeta" @click="lp60GuardarTarjeta()">   
      </div>
      <div class="col-1">&nbsp;</div>
    </div>
    <div v-if="lbMostrarGuardarTarjeta"><hr/></div>

    <!-- Leyenda para "Se va a utilizar la siguiente tarjeta ..." -->
    <div class="row" v-if="lbMostrarTarjetaGuardada">
      <div class="igs-l3 igs-color1 igs-center col-12">Se utilizará la siguiente tarjeta para el pago :</div>
      <div class="igs-l3 igs-color7 igs-center col-12">{{$store.state.strTPVLeyendaDatosTarjeta}}</div>
    </div>
    <div v-if="lbMostrarTarjetaGuardada"><hr/></div>

    <div class="row">
      <div class="col-12 igs-l2 igs-center">Para confirmar el pago pulse el botón PAGAR. <br/></div>
    </div>

    <!--
    <div class="igs-h4 igs-color2 igs-center">{{$store.state.strTPVMensajeTitulo}}</div>
    <div class="igs-h3 igs-color1 igs-center">{{$store.state.strTPVMensajeSubtitulo}}</div>
    -->

    <br/>

    <form ref="TPVRedSys" id="TPVRedSys" :action="ltURL" method="POST">
        <input type="hidden" name="Ds_SignatureVersion"     :value="ltSignatureVersion" />
        <input type="hidden" name="Ds_MerchantParameters"   :value="ltMerchantParameters" />
        <input type="hidden" name="Ds_Signature"            :value="ltSignature" />
        <input type="submit" value="Pagar" class="btn btn-lg btn-outline-dark" ref="TPVRedSys_Enviar">
    </form>      
        <!-- <a href="" ref="TPVRedSys_Enviar" @click="lp70Submit()">Pagar</a> -->
  </div>

  <!--
  <div>
      <div><h1>SignatureVersion</h1>{{ltSignatureVersion}}</div>
      <div><h1>MerchantParameters</h1>{{ltMerchantParameters}}</div>
      <div><h1>Signature</h1>{{ltSignature}}</div>
  </div>
  
  <BNC10000></BNC10000>
  -->

</div>
</template>

<script>
import igs_mixin from '@/igs-mixins/igs_mixin'
const  axios = require("axios")


//import TNC10000  from '@/igs-navegacion/TNC10000'
//import BNC10000  from '@/igs-navegacion/BNC10000'

export default {
  mixins: [ igs_mixin ],
  //components : { TNC10000, BNC10000 },

  //=======================================================================
  //------------------------ Variables Locales  ---------------------------
  //=======================================================================
  el : "#formRoot",

  data() {
    return {
        lSWModoProduccion               : false,
        ltSignatureVersion              : '',
        ltMerchantParameters            : '',
        ltSignature                     : '',
        ltURL                           : '',
        ltGuardarTarjeta                : '0',
        ltSavedTPVMerchantIdentifier    : '',

        lbOperacionBizum                : false,
        lbOperacionAutenticacion        : false,
        lbMostrarGuardarTarjeta         : false,
        lbMostrarTarjetaGuardada        : false  
    }
  },

  //=======================================================================
  //------------------------ Variables Calculadas  ---------------------------
  //=======================================================================
  computed : {

  },


  //=======================================================================
  //------------------------ Métodos Locales  ---------------------------
  //=======================================================================
  methods: {

    //--------------------------------------------------------------------------------
    //-- Animación Inicial al Mostrar la Página de Login
    //--------------------------------------------------------------------------------
    // eslint-disable-next-line no-unused-vars
    onPageLoaded (args) {

      //-- Ocultar Indicadores de Actividad
      this.$store.commit('p10StrRecibiendoDatos', false);

    },


    //--------------------------------------------------------------------------------
    //-- Iniciar una Nueva Transacción (TPV Redsys)
    //--------------------------------------------------------------------------------
    lp50IniciarTransaccion() {

        console.log('-- Inicio Petición Autorización --');

        const {
            Redsys,
            SANDBOX_URLS,
            PRODUCTION_URLS,
            TRANSACTION_TYPES,
            //randomTransactionId
        } = require('redsys-easy')

        //-- Extraer valores a utilizar en este Método
        var indiceTPV             = this.$store.state.strT001M030_Indice;  // Valores : 1, 2, ..., n
        if (indiceTPV > 0) { indiceTPV = indiceTPV - 1; }                  // Aplicar : 0, 1, ..., n-1

        var secretTPV             = this.f75DesofuscarTexto(this.$store.state.strT001M030[indiceTPV].secretComercio);
        var nombreComercioTPV     = this.$store.state.strT001M030[indiceTPV].nombreComercio;
        var codigoComercioTPV     = this.$store.state.strT001M030[indiceTPV].codigoComercio;
        var terminalComercioTPV   = this.$store.state.strT001M030[indiceTPV].terminalComercio;
        //var urlComercioTPV        = this.$store.state.strT001M030[indiceTPV].urlComercio;
        var urlConfirmacionOnline = this.$store.state.strT001M030[indiceTPV].urlConfirmacionOnline;

        //-- Valores Específicos del Pedido
        var referenciaPedido      = this.$store.state.strReferenciaPedido;
        var importePedido         = this.$store.state.strImportePedido;

        console.log(' codigoComercio : '+codigoComercioTPV);
        console.log(' terminalComercio : '+terminalComercioTPV);
        console.log(' secretTPV : '+secretTPV);
        console.log(' ReferenciaPedido : '+referenciaPedido);
        console.log(' ImportePedido : '+importePedido);

        //-- (a) URLs del Panel : Desarrollo ó Producción
        var URLPanel  = 'http://' + window.location.hostname + ':8080';
        if (window.location.hostname == "panel.ihoreca.es") { URLPanel  = "https://panel.ihoreca.es"; }

        //-- (b) URLs TPV Virtual : Prueba ó Producción
        var URLsTPV   = SANDBOX_URLS;
        if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  URLsTPV = PRODUCTION_URLS; }

        //-- Comenzar la creación del OBJETO a enviar al TPV
        const redsys = new Redsys({
            secretKey:  secretTPV,
            urls:       URLsTPV, 
        });

        //-- Aplicar el parámetro adecuado cuando se AUTORIZA CONSERVAR la TARJETA para (Uso Futuro)
        if (this.ltGuardarTarjeta == '1') {
          this.$store.commit('p10StrTPVMerchantIdentifier', 'REQUIRED');
        } else {
          this.$store.commit('p10StrTPVMerchantIdentifier', this.ltSavedTPVMerchantIdentifier);
        }


        var merchantData = this.$store.state.strDistribuidor + this.$store.state.strUsuario + 'C' + this.$store.state.strCliente + 'R' + this.$store.state.strReferenciaPedido + 'M' + this.ltGuardarTarjeta + 'I' + this.$store.state.strImportePedido;

        if (urlConfirmacionOnline != '') {
          merchantData = this.$store.state.strDistribuidor + this.$store.state.strUsuario + 
                                  'C' + this.$store.state.strCliente + 'R' + this.$store.state.strReferenciaPedido + 
                                  'M' + this.ltGuardarTarjeta + 'I' + this.$store.state.strImportePedido + '|' +
                                  's='+this.$store.state.strIDSesion+
                                  '&u='+this.$store.state.strUsuario+
                                  '&d='+this.$store.state.strDistribuidor+
                                  '&c='+this.$store.state.strCliente+
                                  '&t=230&m=911'+
                                  '&n='+this.$store.state.strNifClienteOfuscado+
                                  '&x='+this.$store.state.strReferenciaPedido;
        }

        console.log(merchantData);

        //-- Determinar el Tipo de Transacción
        var tipoTransaccion = TRANSACTION_TYPES.AUTHORIZATION;                                                                           //-- (0)=Autorización Inmediata

        if (this.$store.state.strTPVMerchantPayMethods == '1') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHORIZATION; }                //-- (1)=Solicitud    Pre-Autorización  para Cargo Posterior (Con Bloqueo de Importe)
        if (this.$store.state.strTPVMerchantPayMethods == '2') { tipoTransaccion = TRANSACTION_TYPES.CONFIRMATION; }                     //-- (1)=Confirmación Pre-Autorización  para Cargo Posterior (Operación Firme)
        if (this.$store.state.strTPVMerchantPayMethods == '9') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHORIZATION_CANCEL; }         //-- (9)=Cancelación  Pre-Autorización  para Cargo Posterior (Liberación del Bloqueo Inicial)
                                                                                  
        if (this.$store.state.strTPVMerchantPayMethods == '7') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHENTICATION; }                //-- (7)=Solicitud    Pre-Autenticación para Cargo Posterior (Sin Bloqueo de Importe)
        if (this.$store.state.strTPVMerchantPayMethods == '8') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHENTICATION_CONFIRMATION; }   //-- (8)=Confirmación Pre-Autenticación para Cargo Posterior (Operación Firme)

        const obj = {
            amount: importePedido,                                          //-- Importe (en Céntimos de Euro)
            currency: 'EUR',                                                //-- Moneda
            order: referenciaPedido,                                        //-- Número de Referencia               
            merchantName: nombreComercioTPV,                                //-- Nombre de la Empresa / Comercio
            merchantCode: codigoComercioTPV,                                //-- Código de la Tienda / Comercio
            terminal: terminalComercioTPV,                                  //-- Número de Terminal
            transactionType: tipoTransaccion,                               //-- Tipo de Transacción
            merchantURL: urlConfirmacionOnline,                             //-- URL del Comercio
            productDescription : this.$store.state.strTPVMensajeTitulo + ' ' + this.$store.state.strTPVMensajeSubtitulo, //-- Descripción de la Operación
            smsTemplate : '@COMERCIO@. Ya puede pagar su recibo de @IMPORTE@ @MONEDA@ en la siguiente url: @URL@',       //-- Mensaje PayGold
            successURL: URLPanel + '/95000/' + this.$store.state.strDistribuidor        + '/' + 
                                               this.$store.state.strUsuario             + '/' + 
                                               this.$store.state.strIDSesion            + '/' + 
                                               this.$store.state.strCliente             + '/' + 
                                               this.$store.state.strNifClienteOfuscado  + '/' + 
                                               this.$store.state.strReferenciaPedido    + '/' + 
                                               this.$store.state.strImportePedido       + '/',
            errorURL:   URLPanel + '/95000/' + this.$store.state.strDistribuidor        + '/' + 
                                               this.$store.state.strUsuario             + '/' + 
                                               this.$store.state.strIDSesion            + '/' + 
                                               this.$store.state.strCliente             + '/' + 
                                               this.$store.state.strNifClienteOfuscado  + '/' +
                                               this.$store.state.strReferenciaPedido    + '/' + 
                                               this.$store.state.strImportePedido       +'/',
            raw: {  
              //-- Referencia Adicional (Texto Libre, como referencia para el Comercio)
              DS_MERCHANT_MERCHANTDATA: merchantData,

              //-- Bizum : Debe incluirse el valor (z) dentro de DS_MERCHANT_PAYMETHODS 
              DS_MERCHANT_PAYMETHODS: this.$store.state.strTPVMerchantPayMethods,

              //-- Visa, MasterCard, ... 
              //--  ""         : Interfaz habitual, con introducción del PAN, Caducidad, CVC, CIP, ...
              //--  "REQUIRED" : Interfaz habitual + Solicitud de respuesta incluyendo IDENTIFICADOR para uso Futuro en modo 1-Click
              //--  "otro valor" : Valor del IDENTIFICADOR recibido cuando se solicitó la operación en modo "REQUIRED"
              DS_MERCHANT_IDENTIFIER: this.$store.state.strTPVMerchantIdentifier
            }
        }


        //-- Debug
        const result = redsys.redirectPetition(obj);
        console.log(result);

        //-- Establecer Valor para las variables del Formulario
        this.ltURL                  = result.url;
        this.ltSignatureVersion     = result.body.Ds_SignatureVersion;
        this.ltMerchantParameters   = result.body.Ds_MerchantParameters;
        this.ltSignature            = result.body.Ds_Signature;

        //-- DEBUG
        //console.log('-- Paso .1. --');
        //console.dir(result.body);

        //-- Efectuar la Petición de Autorización
        //this.$refs.TPVRedSys.$el.submit();
        //this.$refs.TPVRedSys_Enviar.click();

        //-- La CONFIRMACIÓN ó CANCELACIÓN de una "Pre-Autorización" y/o "Pre-Autenticación" no requiere PAUSA para que el usuario confirme la operación
        if ((this.$store.state.strTPVMerchantPayMethods == '2') || (this.$store.state.strTPVMerchantPayMethods == '8') || (this.$store.state.strTPVMerchantPayMethods == '9')) {
          //this.$refs.TPVRedSys_Enviar.click();
          setTimeout(() => {  this.$refs.TPVRedSys_Enviar.click(); }, 100);
        }

    },

    //------------------------------------------------------
    //-- Conmutar valor de la Check "Guardar Tarjeta"
    //------------------------------------------------------
    lp60GuardarTarjeta() {

      //-- Conmutar y Conservar el Valor de la "CheckBox"
      if (this.ltGuardarTarjeta == '0') {
        this.ltGuardarTarjeta                 = '1';
        this.$refs.rfGuardarTarjeta.checked   = true;
      } else {
        this.ltGuardarTarjeta                 = '0';
        this.$refs.rfGuardarTarjeta.checked   = false;
      }

      //-- Recalcular Transacción
      this.lp50IniciarTransaccion();

      //console.log(' lp60GuardarTarjeta : '+this.ltGuardarTarjeta);
    },


    /*
    lp70Submit() {
        this.$refs.TPVRedSys.submit();
        //window.$('#TPVRedSys').submit();
        this.$refs.TPVRedSys_Enviar.click();
    },
    */

    //------------------------------------------------------
    //-- Reclamar Lista de TPV Virtuales disponibles
    //------------------------------------------------------
    lp98t001m030() {
      
      var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+"&u="+this.$store.state.strUsuario+"&t=001&m=030";
      //console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.t001m030) {
              //-- Debug
              //console.log('-- Lista de TPVs OK --');
              //console.log('** Array **');
              //console.dir(datos.t001m030);
              //console.log('** Índice **');
              //console.dir(datos.t001m030_indice);
              //console.log('----------------------');
              
              //-- Actualizar Información relacionada con los TPVs
              this.$store.commit('p10StrT001M030',        datos.t001m030);
              this.$store.commit('p10StrT001M030_Indice', datos.t001m030_indice);

              //var i = this.$store.state.strT001M030_Indice;
              //console.log(' (A) Índice = '+i);


              //-- Solicitar Autorización para el PAGO
              this.lp50IniciarTransaccion();
            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error TPV91000<br/>'+respuesta.data.msg,-1);
            }
                
        })
        .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
        });

    }


  },

  //=======================================================================
  //------------ Métodos a aplicar una vez CARGADA la Página  -------------
  //=======================================================================
  mounted() {
    //console.log('SVC91000 mounted');

    //-- Conservar el Valor de (strTPVMerchantIdentifier)
    this.ltSavedTPVMerchantIdentifier = this.$store.state.strTPVMerchantIdentifier;
    console.log('ltSavedTPVMerchantIdentified = ('+this.$store.state.strTPVMerchantIdentifier+')');

    //-- Mostrar Leyenda "Guardar Tarjeta"
    if ((this.ltSavedTPVMerchantIdentifier == '') && (this.$store.state.strTPVMerchantPayMethods != 'z')) { this.lbMostrarGuardarTarjeta    = true; }

    //-- Mostrar Leyenda "Se va a utilizar la siguiente tarjeta ..."
    if ((this.ltSavedTPVMerchantIdentifier != '') && (this.$store.state.strTPVMerchantPayMethods != 'z')) { this.lbMostrarTarjetaGuardada   = true; }

    //-- Determinar si se trata de una Operación de Autenticación (Pre-Autorización para Cargo Posterior)
    if (this.$store.state.strTPVMerchantPayMethods == '1') { this.lbOperacionAutenticacion  = true; }  //-- PreAutorización  (CON Bloqueo de Importe en Cuenta del Cliente)
    if (this.$store.state.strTPVMerchantPayMethods == '7') { this.lbOperacionAutenticacion  = true; }  //-- PreAutenticación (SIN Bloqueo de Importe en Cuenta del Cliente)

    //-- Determinar si se trata de una Operación BIZUM (o no)
    if (this.$store.state.strTPVMerchantPayMethods == 'z') { this.lbOperacionBizum          = true; }


    //this.lp50IniciarTransaccion();
    this.lp98t001m030();

  }
}


/*
================================================================================================================================================
    DATOS GENÉRICOS DE PRUEBA
================================================================================================================================================

        Para la realizacion de pruebas, cada comercio debe utilizar sus valores facilitados por su entidad para lo siguientes parámetros:

            (1) Número de comercio (Ds_Merchant_MerchantCode)
            (2) Terminal (Ds_Merchant_Terminal)
            (3) Clave secreta

    ..............................................................................................................................................

        Tarjeta aceptada:
            Numeración: 4548 8120 4940 0004
            Caducidad: 12/20
            Código CVV2: 123

        En modo de compra segura (CES), en la que se requiera autenticación del comprador, el código de identificación personal (CIP) es: 
            123456


        *************************************************************************************************************************
        ************************************************    Ejemplo de URL OK   *************************************************
        *************************************************************************************************************************
        https://panel.ihoreca.es/95000?Ds_SignatureVersion=HMAC_SHA256_V1&Ds_MerchantParameters=eyJEc19EYXRlIjoiMjUlMkYwNCUyRjIwMjAiLCJEc19Ib3VyIjoiMDAlM0EzMCIsIkRzX1NlY3VyZVBheW1lbnQiOiIxIiwiRHNfQW1vdW50IjoiMTIzNCIsIkRzX0N1cnJlbmN5IjoiOTc4IiwiRHNfT3JkZXIiOiIxN0gxMjM0NTYiLCJEc19NZXJjaGFudENvZGUiOiI5OTkwMDg4ODEiLCJEc19UZXJtaW5hbCI6IjAwMSIsIkRzX1Jlc3BvbnNlIjoiMDAwMCIsIkRzX1RyYW5zYWN0aW9uVHlwZSI6IjAiLCJEc19NZXJjaGFudERhdGEiOiJEMDAwMDAwVTAwMDAwMUMwMDAxNDgiLCJEc19BdXRob3Jpc2F0aW9uQ29kZSI6IjE1OTk3NSIsIkRzX0NhcmRfTnVtYmVyIjoiNDU0ODgxKioqKioqMDAwNCIsIkRzX0NvbnN1bWVyTGFuZ3VhZ2UiOiIxIiwiRHNfQ2FyZF9Db3VudHJ5IjoiNzI0IiwiRHNfQ2FyZF9CcmFuZCI6IjEifQ==&Ds_Signature=2XNK9M7zGWEU4dxiZQK7GoU7e23HoySyamavLY8hWDw=
        *************************************************************************************************************************

    ..............................................................................................................................................

        Tarjeta rechazada:
            Numeración: 5576 4400 2278 8500
            Caducidad: 12/20
            Código CVV2: 123

        En modo de compra segura (CES), en la que se requiera autenticación del comprador, el código de identificación personal (CIP) es: 
            123456

*/

</script>

<style type="scope">
</style>

